import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@helsenorge/designsystem-react/components/Button';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import SearchIcon from '@helsenorge/designsystem-react/components/Icons/Search';
import { useIsMobileBreakpoint } from '@helsenorge/designsystem-react/hooks/useIsMobileBreakpoint';
import BasicInput from './basic-input';
import SearchAutoSuggest from './search-autosuggest';
import styles from './styles.module.scss';
/**
 * Komponent for søkefelt, med valgfri autosuggest
 */
const SearchInput = ({ query, searchUrl, enableAutosuggest = false, shouldRenderSuggestions = false, onChange, onSubmit, inputAriaLabel, containerAriaLabel, submitButtonText, invert = false, autoFocus = false, size = 'normal', }) => {
    const isMobile = useIsMobileBreakpoint();
    const handleSubmit = (e) => {
        e.preventDefault();
        const value = new FormData(e.currentTarget).get('query');
        if (typeof value === 'string') {
            onSubmit(value, 'input');
        }
    };
    return (_jsxs("form", { onSubmit: handleSubmit, className: styles['search-input'], children: [enableAutosuggest ? (_jsx(SearchAutoSuggest, { query: query, searchUrl: searchUrl, shouldRenderSuggestions: shouldRenderSuggestions, inputAriaLabel: inputAriaLabel, containerAriaLabel: containerAriaLabel ?? inputAriaLabel, autoFocus: autoFocus, onChange: onChange, onSubmit: onSubmit })) : (_jsx(BasicInput, { query: query, inputAriaLabel: inputAriaLabel, onChange: onChange, size: size, autoFocus: autoFocus })), _jsxs(Button, { type: "submit", variant: invert ? 'outline' : undefined, onColor: invert ? 'ondark' : 'onlight', size: !enableAutosuggest && size === 'large' ? 'large' : 'normal', children: [!isMobile && _jsx(Icon, { size: 32, color: "white", svgIcon: SearchIcon }), submitButtonText] })] }));
};
export default SearchInput;
